import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=1fcdc056"
import script from "./merchant.vue?vue&type=script&lang=js"
export * from "./merchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports